const selectArticles = (state, statKey, page, idxStart, idxEnd) => {
	const articles = state.articles;

	if (articles[statKey] && articles[statKey][page]) {
		const totalItems = articles[statKey].totalItems;
		return [articles[statKey][page].slice(idxStart, idxEnd), totalItems];
	} else {
		return [[], 0];
	}
};

const selectProducts = (state, statKey, page) => {
	const products = state.products;

	if (products[statKey]) {
		const totalItems = products[statKey].totalItems;
		return [products[statKey][page], totalItems];
	} else {
		return [[], 0];
	}
};

export {
	selectArticles,
	selectProducts,
};
